// Modules
import {GetServerSideProps, GetServerSidePropsResult} from "next";

// Components
import PageContent from "containers/PageContent/PageContents";
import MainLayout from "components/MainLayout";

// Services
import serverSideFunction from "services/serverFunctions/serverSideFunction";

// Types
import { NextPageWithLayout } from "interfaces/shared/page";

export const getServerSideProps: GetServerSideProps<{}> = async (context) => {
	const serverSideProps: GetServerSidePropsResult<{}> = await serverSideFunction(context);
	return serverSideProps;
};

const FormazioneSlug: NextPageWithLayout = (): JSX.Element => {
	return <PageContent />;
};

FormazioneSlug.getLayout = (page) => (
	<MainLayout>
		{page}
	</MainLayout>
);

export default FormazioneSlug;
